import React, { useEffect, useState } from 'react';
import { report_info, table_headers } from './Javascript/ReportObjects';
import { convertCoordinates, waypoints_only} from './Javascript/CustomiseReport';
import './CSS/style.css';

interface Props {
  route_details: [];
  waypointOnly: boolean;
}
const change_coord_format = (value: string) => {
    convertCoordinates(value);
};

const DetailsTable: React.FC<Props> = ({ route_details,  waypointOnly}) => {
    var point_url = "Images/Assets/point.png";
    const [details_data, set_details_data] = useState<[] | null>(null);
    const [waypoint_data_only, set_waypoint_data_only] = useState<boolean>(waypointOnly);

    useEffect(() => {
      const fetchData = async () => {
          try {
              if (route_details != null && details_data == null) {
                 //console.log("waypoint_data_only: ", waypoint_data_only);
                 set_details_data(route_details);
              }
          }
          catch (error) {
              console.error(error);
          }
      };

    fetchData();
    }, [details_data]);

	const applyWaypointFilter = () => {
		set_details_data(waypoints_only(route_details));
	};

    useEffect(() => {
        if (waypoint_data_only) {
            applyWaypointFilter();
        } else {
            set_details_data(route_details);
        }
    }, [waypoint_data_only]);

	const headers = waypoint_data_only ? ['Way', ...table_headers.slice(1)] : table_headers;

    return (
    <div>
        <button style={{display:'none'}} type="button" id="waypoint_details_only" onClick={(e) => set_waypoint_data_only(prev => !prev)}>Waypoints Only</button>

        <div className="user_custom_container">
            <select id="format_selector" onChange={(e) => change_coord_format(e.target.value)}>
                <option value="Decimal">Decimal</option>
                <option value="Decimal degrees">Decimal degrees</option>
                <option value="Degrees, decimal minutes">Degrees, decimal minutes</option>
                <option value="Degrees, minutes, seconds">Degrees, minutes, seconds</option>
            </select>
        </div>

        <div id="detailed_table_section" className="report_row">
            <div className="inner_padding">

                <p className="sub_title">Detailed Analysis</p>

                <table className="detailed_class">
                    <thead>
                        <tr>
							<th colSpan={headers.length - 5} style={{ border: 'none', marginRight: 0, marginLeft: 'auto' }}>

                            </th>
                            <th colSpan={5} style={{ marginRight: 0, marginLeft: 'auto' }}>
                                MARPOL
                            </th>
                        </tr>
                        <tr>
							{headers.map((str, index) => (
								<th key={index + headers.length} colSpan={str === 'MARPOL' ? 0 : 1}>
									{str !== 'MARPOL' && str}
								</th>
							))}
                        </tr>
                    </thead>
                    <tbody>
                    {details_data && details_data.map((item: any, index) => (
                        /* using this method i could set up some kind of mapping
                        system/array between header names and the variables so that the table becomes fully dynamic in the columns it can show*/
                        <tr key={index}>
						<td>{waypoint_data_only ? item?.waypoint_number : item?.position_number}</td>
                            <td className='latitude'>{item?.position_location.dec["lat"]}</td>
                            <td className='longitude'>{item?.position_location.dec["lon"]}</td>
                            <td>{item?.date_reached}</td>
                            <td>{item?.speed.knots}</td>
                            <td>{item?.freeboard}</td>
                            <td>{item?.mitigations}</td>
                            <td style={{
                                  background: item?.risk_colour_hex,
                                  color: (
                                    item?.risk_string === 'HIGH' || item?.risk_string === 'EXTREME'
                                  ) ? 'white' : 'black'
                                }} >{item?.risk_string}</td>
                            <td>{item?.eez_name}</td>
                            <td>{item?.sea_name}</td>
                            <td>{item?.jwc_name}</td>
                            <td>{item?.marpol_eca && 'X'}</td>
                            <td>{item?.marpol_garbage && 'X'}</td>
                            <td>{item?.marpol_noxious_liquid && 'X'}</td>
                            <td>{item?.marpol_oil && 'X'}</td>
                            <td>{item?.marpol_sewage && 'X'}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    );
};

/*

we can allow the user to customise the table by having an original table variable that never changes and
a current table changed to reflect the users requirements this can then by dynamically generated using the
code below. Will also require a function to track the position of the risk column for the colour coding and a
method of detecting whether the table is too large to fit on an A4 page

{route_details?.route?.map((item: any, index) => (
    <tr key={index}>
        {Object.keys(item).map((key, index) => (
            <td key={index}>{item[key]}</td>
        ))}
    </tr>
))}
*/

export default DetailsTable;
